<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm_title"><span class="bold">List of Maps</span></h2>
<p class="noindent-b"><span class="bold">Note:</span> <em class="italic">Unless otherwise stated, the maps are extracts from trench maps or from the relevant histories; the sketch and tour maps were prepared for this book.</em></p>
<p class="num"><span class="numhang">1.</span> Modern map showing the area of the British sector of the Somme 1916 battlefield.</p>
<p class="num"><span class="numhang">2.</span> Modern detailed map of the fighting from Martinpuich to the Butte de Warlencourt.</p>
<p class="num"><span class="numhang">3.</span> The area of the Fourth Army’s operations: 15 September 1916.</p>
<p class="num"><span class="numhang">4.</span> Sketch map illustrating the attack of 15 September 1916 (the 15th, 50th and 47th Divisions).</p>
<p class="num"><span class="numhang">5.</span> Location of trenches in the Martinpuich area, map dated 30 July 1916.</p>
<p class="num"><span class="numhang">6.</span> Sketch map illustrating the attack of the 15th Division on Martinpuich, 15 September 1916.</p>
<p class="num"><span class="numhang">7.</span> The area over which the 50th Division attacked on 15 September 1916.</p>
<p class="num"><span class="numhang">8.</span> The 47th Division’s front on 15 September 1916.</p>
<p class="num"><span class="numhang">9.</span> Overview of the fighting of 1–3 October 1916, showing the positions of the 47th, 50th and 23rd Divisions.</p>
<p class="num-1"><span class="numhangj">10.</span> Modern map covering the area of operations on 7–8 October 1916.</p>
<p class="num-1"><span class="numhangj">11.</span> The trenches around Le Sars.</p>
<p class="num-1"><span class="numhangj">12.</span> Le Sars and Eaucourt L’Abbaye, showing the site of the ‘Mill’.</p>
<p class="num-1"><span class="numhangj">13.</span> Map (Eaucourt l’Abbaye to the Butte) of the battlefield, 30 October 1916, from 149 Brigade’s diary.</p>
<p class="num-1"><span class="numhangj">14.</span> The location of the Pimple and several key trenches that featured in the attacks on the Butte.</p>
<p class="num-1"><span class="numhangj">15.</span> Location of The Tail and Snag Trench, dated 1 January 1917.</p>
<p class="num-1"><span class="numhangj">16.</span> The lines around the Butte, 1 January 1917.</p>
<p class="num-1"><span class="numhangj">17.</span> Walking Tour One outline map.</p>
<p class="num-1"><span class="numhangj">18.</span> Walking Tour Two outline map.</p>
<p class="num-1"><span class="numhangj">19.</span> South of Martinpuich, dated September 1916.</p>
<p class="num-1"><span class="numhangj">20.</span> Trenches north of the High Wood to Bazentin road.</p>
<a id="page_vii"></a>
<p class="num-1"><span class="numhangj">21.</span> Trenches north and north west of Bazentin le Petit to north west edge of High Wood, dated September 1916.</p>
<p class="num-1"><span class="numhangj">22.</span> Locations of Tangle Trench and Tangle South and North, dated 29 September 1916.</p>
<p class="num-1"><span class="numhangj">23.</span> Car Tour outline map.</p>
<p class="num-1"><span class="numhangj">24.</span> Le Sars and area, September 1916.</p>
<p class="num-1"><span class="numhangj">25.</span> Sketch map of the 1870–71 battlefield around Bapaume.</p>
<p class="num-1"><span class="numhangj">26.</span> German defences around Grévillers, Sapignies and Favreuil, dated 27 November 1916.</p>
<p class="num-1"><span class="numhangj">27.</span> Detail of German defences, including Grevillers, Coulle and Grundy trenches, dated 1 January 1917.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List-Maps.vue?197d6150